import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconVoiceComponent } from "./med-icon-voice.component";

@NgModule({
  declarations: [
    MedIconVoiceComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconVoiceComponent,
  ],
})
export class MedIconVoiceModule { }
